module.exports = __webpack_public_path__ + "img/moe_logo_ru.d854d0ae.svg";